import { parseDraftResourceLinkMeta } from "@qw/qw-common";
import type { FC } from "react";

import { getResourceLinkTitle } from "../../chat.helpers";
import type { McpResourceLink } from "../../chat.types";
import { ArtifactRowButton } from "./artifact-row-button";

export const DraftArtifactRow: FC<{ resource: McpResourceLink }> = ({ resource }) => {
  const meta = parseDraftResourceLinkMeta(resource._meta);
  const subject = meta?.subject || getResourceLinkTitle(resource);
  const recipients = (meta?.to ?? []).join(", ");

  return (
    <ArtifactRowButton resource={resource} icon="mail">
      <span className="min-w-0 flex-1">
        <span className="block truncate text-sm">{subject}</span>
        {recipients ? (
          <span className="mt-0.5 block truncate text-xs text-muted-foreground">To: {recipients}</span>
        ) : null}
      </span>
    </ArtifactRowButton>
  );
};
